const initialStates = [
    {
        id: 1,
        img: "https://images.unsplash.com/photo-1607798748738-b15c40d33d57?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80",
        title: "The easiest way to learn redux",
        category: "Tech",
        authorName: "Sumit Saha",
        authorImg:
            "https://learnwithsumit.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Finstructor.de111715.jpg&w=640&q=75",
        createdAt: "10 august, 2022",
        minRead: 5,
    },

    {
        id: 2,
        img: "https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80",
        title: "Five Beautiful Places To Visit This Fall",
        category: "Travel",
        authorName: "Delan alan",
        authorImg:
            "https://i.pinimg.com/originals/ae/ec/c2/aeecc22a67dac7987a80ac0724658493.jpg",
        createdAt: "09 march, 2022",
        minRead: 15,
    },
    {
        id: 3,
        img: "https://images.unsplash.com/photo-1607962837359-5e7e89f86776?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80",
        title: "Here’s Exactly How Much You Need To Exercise for The Best Results",
        category: "Health and Fitness",
        authorName: "Ange dim",
        authorImg:
            "https://cdn-images-1.medium.com/fit/c/36/36/1*OF3Qd35OyUVtA7sQwC-imA.jpeg",
        createdAt: "20 november, 2022",
        minRead: 14,
    },
    {
        id: 4,
        img: "https://images.unsplash.com/photo-1526379095098-d400fd0bf935?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1032&q=80",
        title: "A Practical 12-Week Course to Learn to Automate Stuff with Python",
        category: "Tech",
        authorName: "Hitesh Choudhary",
        authorImg:
            "https://images.unsplash.com/profile-fb-1504778944-f3b1fd2f8214.jpg?dpr=1&auto=format&fit=crop&w=150&h=150&q=60&crop=faces&bg=fff",
        createdAt: "11 Jul, 2022",
        minRead: 6,
    },
    {
        id: 5,
        img: "https://images.unsplash.com/photo-1488085061387-422e29b40080?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1031&q=80",
        title: "Flying To New Memories",
        category: "Travel",
        authorName: "Nataly Ce",
        authorImg: "https://randomuser.me/api/portraits/women/90.jpg",
        createdAt: "18 april, 2022",
        minRead: 9,
    },
    {
        id: 6,
        img: "https://images.unsplash.com/photo-1493770348161-369560ae357d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80",
        title: "10 Unusual Things That Can Actually Be Eaten",
        category: "Foods",
        authorName: "Tabby camao",
        authorImg: "https://randomuser.me/api/portraits/men/83.jpg",
        createdAt: "02 july, 2022",
        minRead: 11,
    },
    {
        id: 7,
        img: "https://images.unsplash.com/photo-1591453089816-0fbb971b454c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80",
        title: "Everything you’ve ever wanted to know about machine learning",
        category: "Tech",
        authorName: "Hitesh Choudhary",
        authorImg:
            "https://images.unsplash.com/profile-fb-1504778944-f3b1fd2f8214.jpg?dpr=1&auto=format&fit=crop&w=150&h=150&q=60&crop=faces&bg=fff",
        createdAt: "05 august, 2022",
        minRead: 8,
    },
    {
        id: 8,
        img: "https://images.unsplash.com/photo-1504674900247-0877df9cc836?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80",
        title: "Eating right when bad information is everywhere.",
        category: "Foods",
        authorName: "Chriss mos",
        authorImg: "https://randomuser.me/api/portraits/men/75.jpg",
        createdAt: "02 february, 2022",
        minRead: 7,
    },
    {
        id: 9,
        img: "https://images.unsplash.com/flagged/photo-1557040430-fe79b4234586?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80",
        title: "The Truth on How to Lose Stubborn Belly Fat Fast",
        category: "Health and Fitness",
        authorName: "Delan alan",
        authorImg:
            "https://i.pinimg.com/originals/ae/ec/c2/aeecc22a67dac7987a80ac0724658493.jpg",
        createdAt: "02 november, 2022",
        minRead: 9,
    },

    {
        id: 10,
        img: "https://images.unsplash.com/photo-1506268452458-bfb3757ed859?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=869&q=80",
        title: "Five Tips to Keep Your Mind Sane When Living Abroad Alone.",
        category: "Travel",
        authorName: "Nataly Ce",
        authorImg: "https://randomuser.me/api/portraits/women/90.jpg",
        createdAt: "09 april, 2022",
        minRead: 18,
    },
    {
        id: 11,
        img: "https://images.unsplash.com/photo-1420641519650-9d7d0ea0a829?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=874&q=80",
        title: "Faster Weight Loss With This One Key Training Method",
        category: "Health and Fitness",
        authorName: "Ange dim",
        authorImg:
            "https://cdn-images-1.medium.com/fit/c/36/36/1*OF3Qd35OyUVtA7sQwC-imA.jpeg",
        createdAt: "02 december, 2022",
        minRead: 19,
    },

    {
        id: 12,
        img: "https://images.unsplash.com/photo-1646047354754-6e86d4d9fc68?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80",
        title: "How Russia Is One of the Most Unequal Countries on the Entire Planet",
        category: "Finance",
        authorName: "Lobi borba",
        authorImg:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSXUv6ZrOiS4QQaWCBlsw2zbj64_mcv8Bk-ZCLwDSWLznS_Iu2bxfnet_eaChBoikcPoCc&usqp=CAU",
        createdAt: "10 july, 2022",
        minRead: 20,
    },
];

export default initialStates;
